import { createStructuredSelector } from 'reselect';

import { getCurrencyCode, getLanguageCode } from '../modules/app/selectors';

// @ts-expect-error $TSFixMeError: No overload matches this call.
export const localizationMapper = createStructuredSelector({
    languageCode: getLanguageCode,
    currencyCode: getCurrencyCode,
});
